import { type AfterViewInit, Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { HlmToasterComponent } from "@spartan-ng/ui-helm-helm";
import { environment } from "src/environments/environment";
import { OpenReplayService, UserPreferenceService } from "./services";
import { Script, ScriptInjector } from "./utils";

@Component({
	selector: "root",
	standalone: true,
	imports: [RouterOutlet, HlmToasterComponent],
	templateUrl: "./app.component.html",
	host: { class: "h-full" },
})
export class AppComponent implements AfterViewInit {
	private readonly _scriptInjector = new ScriptInjector();

	private readonly _openReplayService = inject(OpenReplayService);
	private readonly _userPreferenceService = inject(UserPreferenceService);

	public readonly activeTheme = this._userPreferenceService.theme;

	async ngAfterViewInit(): Promise<void> {
		console.log(`Loaded Leasing Platform V1.0.1`);
		const loader = document.querySelector("#loader");
		if (loader && !loader.classList.contains("hidden")) {
			setTimeout(() => loader.classList.add("hidden"), 250);
		}
		this._injectScripts();
		await this._openReplayService.start();
	}

	private _injectScripts(): void {
		const { apiKey } = environment.googleMaps;
		const scripts: Script[] = [
			{
				location: "head",
				content:
					"function initMap() { return new Promise((resolve, reject) => { resolve() }) };",
			},
			{
				location: "head",
				src: `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=en&callback=initMap&loading=async`,
			},
			{
				location: "body",
				src: "https://documentservices.adobe.com/view-sdk/viewer.js",
			},
		];
		this._scriptInjector.inject(...scripts);
	}
}
